module.exports = __webpack_public_path__ + "img/relevance-icon-white.f3bf4347.svg";